<div fxLayout="column">
  <div fxLayout="column" fxLayoutAlign="center center" *ngIf="step === 0">
    <div>
      <img src="assets/images/logo.png" width="150" />
    </div>

    <div fxLayout="column" fxLayoutAlign="start center">
      <div>{{'issue_report.header.1'|translate}}</div>
      <div>{{'issue_report.header.2'|translate}}</div>
    </div>

    <form [formGroup]="forms[step]" class="mt-1" fxLayout="column" fxLayoutAlign="start center">
      <p>{{'issue_report.question.is_related_to_the_last_call' | translate }}?</p>
      <section>
        <mat-radio-group fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="7px"
          formControlName="last_call_problem">
          <mat-radio-button [value]="1">{{'public.button.yes'|translate}}</mat-radio-button>
          <mat-radio-button [value]="0">{{'public.button.no'|translate}}</mat-radio-button>
        </mat-radio-group>

        <mat-error [flexFormControlError]="forms[step].get('last_call_problem')" class="mt-1"
          *ngIf="forms[step].get('last_call_problem').invalid && forms[step].get('last_call_problem').touched"></mat-error>
      </section>
    </form>
  </div>

  <div fxLayout="column" fxLayoutAlign="start center" *ngIf="step === 1">
    <form [formGroup]="forms[step]">
      <section class="mt-1">
        <mat-radio-group fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="7px"
          formControlName="problem_id">
          <mat-radio-button [value]="2">{{'issue_report.problem.audio_quality'|translate}}</mat-radio-button>
          <mat-radio-button [value]="3">{{'issue_report.problem.call_dropped'|translate}}</mat-radio-button>
          <mat-radio-button [value]="1">{{'issue_report.problem.other'|translate}}</mat-radio-button>
        </mat-radio-group>

        <mat-error [flexFormControlError]="forms[step].get('problem_id')" class="mt-1"
          *ngIf="forms[step].get('problem_id').invalid && forms[step].get('problem_id').touched"></mat-error>
      </section>
    </form>
  </div>

  <div class="mt-1" fxLayout="column" fxLayoutAlign="center center" *ngIf="step === 2">
    <div>
      {{'issue_report.label_desc'|translate}}
    </div>
    <div class="issue-desc-wrapper mt-2">
      <form [formGroup]="forms[step]">
        <mat-form-field class="full-width">
          <textarea class="issue-desc" matInput formControlName="desc"></textarea>

          <mat-error [flexFormControlError]="forms[step].get('desc')"
            *ngIf="forms[step].get('desc').invalid && forms[step].get('desc').touched"></mat-error>
        </mat-form-field>
        
      </form>
    </div>
  </div>
</div>
